import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import { LanguageProvider } from './context/LanguageContext';
import { AuthProvider } from './context/AuthContext';
import { FavoritesProvider } from './context/FavoritesContext';
import { InstallProvider } from './context/InstallContext';
import InstallBanner from './components/InstallBanner';
import ProtectedRoute from './components/ProtectedRoute';
import Header from './components/Header';
import Footer from './components/Footer';
import AnalyticsListener from './components/AnalyticsListener';
import CookieBanner from './components/CookieBanner';
import ScrollToTop from './components/ScrollToTop';
import ExitIntentPopup from './components/ExitIntentPopup';
import NotFound from './pages/NotFound';
import Home from './pages/Home';import Properties from './pages/Properties';
import CostaBlanca from './pages/CostaBlanca';
import CostaCalida from './pages/CostaCalida';
import CostaAlmeria from './pages/CostaAlmeria';
import Investeren from './pages/Investeren';
import Blog from './pages/Blog';
import BlogCategory from './pages/BlogCategory';
import BlogDetail from './pages/BlogDetail';
import Contact from './pages/Contact';
import PropertyDetail from './pages/PropertyDetail';
import Favorites from './pages/Favorites';
import Compare from './pages/Compare';
import MapView from './pages/MapView';
import ThankYou from './pages/ThankYou';
import Admin from './pages/Admin';
import AdminLogin from './pages/AdminLogin';
import PrivacyPolicy from './pages/PrivacyPolicy';
import DataDeletion from './pages/DataDeletion';
import CookiesPolicy from './pages/CookiesPolicy';
import TermsConditions from './pages/TermsConditions';
import Disclaimer from './pages/Disclaimer';
import GratisKoopplanner from './pages/GratisKoopplanner';
import Gidsen from './pages/Gidsen';
import Uitschrijven from './pages/Uitschrijven';
import DownloadGids from './pages/DownloadGids';

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <AuthProvider>
          <FavoritesProvider>
            <InstallProvider>
              <Router>
                <ScrollToTop />
                <AnalyticsListener />
                <InstallBanner />
                <div className="App">
                  <Header />
                <main>
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/woningen" element={<Properties />} />
                    <Route path="/properties" element={<Properties />} />
                    <Route path="/kaart" element={<MapView />} />
                    <Route path="/favorieten" element={<Favorites />} />
                    <Route path="/vergelijken" element={<Compare />} />
                    <Route path="/costa-blanca" element={<CostaBlanca />} />
                    <Route path="/costa-calida" element={<CostaCalida />} />
                    <Route path="/costa-almeria" element={<CostaAlmeria />} />
                    <Route path="/investeren" element={<Investeren />} />
                    <Route path="/blog" element={<Blog />} />
                    <Route path="/blog/categorie/:slug" element={<BlogCategory />} />
                    <Route path="/blog/:slug" element={<BlogDetail />} />
                    <Route path="/gratis-koopplanner-spanje" element={<GratisKoopplanner />} />
                    <Route path="/gidsen" element={<Gidsen />} />
                    <Route path="/uitschrijven" element={<Uitschrijven />} />
                    <Route path="/download/:magnetId" element={<DownloadGids />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/bedankt" element={<ThankYou />} />
                    <Route path="/thanks" element={<ThankYou />} />
                    <Route path="/woning/:id" element={<PropertyDetail />} />
                    <Route path="/property/:id" element={<PropertyDetail />} />
                    <Route path="/privacy" element={<PrivacyPolicy />} />
                    <Route path="/gegevens-verwijderen" element={<DataDeletion />} />
                    <Route path="/data-deletion" element={<DataDeletion />} />
                    <Route path="/cookies" element={<CookiesPolicy />} />
                    <Route path="/voorwaarden" element={<TermsConditions />} />
                    <Route path="/terms" element={<TermsConditions />} />
                    <Route path="/disclaimer" element={<Disclaimer />} />
                    <Route path="/admin/login" element={<AdminLogin />} />
                    <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
                    <Route path="*" element={<NotFound />} />
                  </Routes>
                </main>
                <Footer />
                <CookieBanner />
                <ExitIntentPopup />
              </div>
            </Router>
            </InstallProvider>
          </FavoritesProvider>
        </AuthProvider>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;